import ShortUrl from 'pages/ShortUrl';
import { routes } from 'settings/navigation/routes';

export default [{ path: routes.shortUrl, component: ShortUrl }];
